import { render, staticRenderFns } from "./search.vue?vue&type=template&id=156f4065&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156f4065')) {
      api.createRecord('156f4065', component.options)
    } else {
      api.reload('156f4065', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=156f4065&", function () {
      api.rerender('156f4065', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/partials/search.vue"
export default component.exports